module.exports = __webpack_public_path__ + "img/social.ba6e3569.webp";